import { memo } from 'react';

import ArrowShortIconSVG from '@/assets/arrow-down-short-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

export type ArrowShortIconProps = Omit<IconProps, 'SVGComponent'> & {
  rotation: 'up' | 'right' | 'down' | 'left';
};

const IArrowShortIcon = ({ rotation, className, ...rest }: ArrowShortIconProps) => {
  /* prettier-ignore */
  const rotationStyles = [
    rotation === 'up' && 'rotate-180',
    rotation === 'right' && 'rotate-270',
    rotation === 'down' && 'rotate-0',
    rotation === 'left' && 'rotate-90',
  ];

  return <Icon SVGComponent={ArrowShortIconSVG} className={merge(rotationStyles, className)} {...rest} />;
};

export const ArrowShortIcon = memo(IArrowShortIcon) as typeof IArrowShortIcon;
